<script setup lang="ts">
import { useData } from '../../_composables/useData';
import ExpandableCard from '@components/util/ExpandableCard.vue';

const { title, hotelPackage } = useData();
const { isMobile } = useSize();
</script>
<template>
    <div>
        <mr-typography size="x-large" weight="700" type="h2" class="title">
            معرفی {{ title }}
        </mr-typography>
        <ExpandableCard
            :default-height="isMobile ? 171 : 188"
            :data-value="hotelPackage.description"
        >
            <div class="intro-content" v-html="hotelPackage.description" />
        </ExpandableCard>
    </div>
</template>
<style scoped lang="scss">
.title {
    margin-bottom: 8px;
    margin-top: 0;
    display: flex;
    gap: 20px;
    @include mobile-only {
        margin-bottom: 0;
    }
}
.intro-content {
    :deep(p) {
        @include tg-m($color: usePalette($p-cool-gray, $p-800));
        margin-block: 0;
    }
}
</style>
